export default __webpack_public_path__ + "assets/audios/c43caf6fcfd54b4d303308becc1f5a0d.mp3";